"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.REJECTED_OR_CANCELLED_STATUSES = exports.reservationStatusToEventStatus = exports.reservationTypeMapper = exports.reservationStatusMapper = exports.MANDATORY_DRAFT_SLOTS_FIELDS = exports.DEFAULT_PRICE_ID = exports.PRIVATE_NOTES_LIMIT = exports.PUBLIC_NOTES_LIMIT = exports.RESOURCE_TOTAL_FIELD = exports.KEY_TTL = exports.RESERVATION_CHUNCK_SIZE = exports.DRAFT_RESERVATION_REDIS_TOKEN = void 0;
const enums_service_1 = require("../../../services/enums.service");
const reservation_enums_1 = require("../enums/reservation.enums");
exports.DRAFT_RESERVATION_REDIS_TOKEN = 'DRAFT_RESERVATION_REDIS_CLIENT';
exports.RESERVATION_CHUNCK_SIZE = 500;
// 2 days in seconds
exports.KEY_TTL = 172800;
exports.RESOURCE_TOTAL_FIELD = enums_service_1.PriceFieldEnum.TOTAL_PRICE;
exports.PUBLIC_NOTES_LIMIT = 500;
exports.PRIVATE_NOTES_LIMIT = 500;
exports.DEFAULT_PRICE_ID = 0;
exports.MANDATORY_DRAFT_SLOTS_FIELDS = [
    'organizationId',
    'reservationId',
    'facilitiesIds',
    'segmentsIds',
    'ids',
];
exports.reservationStatusMapper = {
    [reservation_enums_1.ReservationStatusEnum.PLANNED]: enums_service_1.InvoiceStatusEnum.DRAFT,
    [reservation_enums_1.ReservationStatusEnum.APPROVED]: enums_service_1.InvoiceStatusEnum.DRAFT,
    [reservation_enums_1.ReservationStatusEnum.AWAITING_ADMIN]: enums_service_1.InvoiceStatusEnum.WAITING_ADMIN,
    [reservation_enums_1.ReservationStatusEnum.AWAITING_CUSTOMER]: enums_service_1.InvoiceStatusEnum.WAITING_CLIENT,
    [reservation_enums_1.ReservationStatusEnum.REJECTED]: enums_service_1.InvoiceStatusEnum.CANCELED,
    [reservation_enums_1.ReservationStatusEnum.CANCELED]: enums_service_1.InvoiceStatusEnum.CANCELED,
};
exports.reservationTypeMapper = {
    [reservation_enums_1.ReservationTypeEnum.CUSTOM]: reservation_enums_1.SlotTypeEnum.CUSTOM,
    [reservation_enums_1.ReservationTypeEnum.MAINTENANCE]: reservation_enums_1.SlotTypeEnum.MAINTENANCE,
    [reservation_enums_1.ReservationTypeEnum.PROGRAM]: reservation_enums_1.SlotTypeEnum.INTERNAL,
    [reservation_enums_1.ReservationTypeEnum.INTERNAL]: reservation_enums_1.SlotTypeEnum.INTERNAL,
    [reservation_enums_1.ReservationTypeEnum.RENTAL]: reservation_enums_1.SlotTypeEnum.EXTERNAL,
};
exports.reservationStatusToEventStatus = {
    [reservation_enums_1.ReservationStatusEnum.PLANNED]: enums_service_1.EventStatusEnum.DRAFT,
    [reservation_enums_1.ReservationStatusEnum.APPROVED]: enums_service_1.EventStatusEnum.OPEN,
    [reservation_enums_1.ReservationStatusEnum.AWAITING_ADMIN]: enums_service_1.EventStatusEnum.DRAFT,
    [reservation_enums_1.ReservationStatusEnum.AWAITING_CUSTOMER]: enums_service_1.EventStatusEnum.DRAFT,
    [reservation_enums_1.ReservationStatusEnum.REJECTED]: enums_service_1.EventStatusEnum.CANCELLED,
    [reservation_enums_1.ReservationStatusEnum.CANCELED]: enums_service_1.EventStatusEnum.CANCELLED,
};
exports.REJECTED_OR_CANCELLED_STATUSES = [
    reservation_enums_1.ReservationStatusEnum.REJECTED,
    reservation_enums_1.ReservationStatusEnum.CANCELED,
];
//# sourceMappingURL=reservation.consts.js.map